import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Twitter, Linkedin, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
export function Footer() {
  return (
    <footer
      className="bg-oc-navy text-white pt-16 pb-8"
      aria-labelledby="footer-heading">
      
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-2">
            <Link
              to="/"
              className="flex items-center gap-3 mb-6"
              data-testid="footer-link-logo">
              <img
                src="/OpenChambers-Logo.png"
                alt="OpenChambers Logo"
                className="h-10 w-auto"
                loading="lazy"
              />
              <span className="font-heading font-bold text-xl tracking-tight">
                OpenChambers
              </span>
            </Link>
            <p className="text-gray-300 mb-6 max-w-sm">
              The Open Operating System for Chambers Worldwide. Powering
              membership, events, advocacy, trade, data, and trust services.
            </p>
            <div className="max-w-sm rounded-lg border border-white/15 p-4 bg-white/5">
              <p className="text-sm text-gray-300 mb-3">
                Need support, partnership guidance, or media access? Use the managed contact workflow.
              </p>
              <Button asChild className="bg-oc-emerald hover:bg-oc-emerald-light text-white" data-testid="footer-btn-contact">
                <Link to="/contact">
                  Contact Us
                  <ArrowRight className="h-4 w-4 ml-2" aria-hidden="true" />
                </Link>
              </Button>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Platform</h3>
            <ul className="space-y-3">
              {[
                { label: 'Membership', href: '/membership' },
                { label: 'Events', href: '/events' },
                { label: 'Advocacy', href: '/advocacy' },
                { label: 'Trade & Trust', href: '/trade-trust' },
                { label: 'Data & Insights', href: '/data-insights' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="text-gray-300 hover:text-white transition-colors"
                    data-testid={`footer-link-platform-${item.label.toLowerCase().replace(/ & /g, '-')}`}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-3">
              {[
                { label: 'Documentation', href: '/docs' },
                { label: 'API Reference', href: '/api-reference' },
                { label: 'Architecture', href: '/architecture' },
                { label: 'Community', href: '/community' },
                { label: 'Roadmap', href: '/roadmap' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="text-gray-300 hover:text-white transition-colors"
                    data-testid={`footer-link-resources-${item.label.toLowerCase().replace(/ /g, '-')}`}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              {[
              {
                label: 'About Us',
                href: '/about'
              },
              {
                label: 'Partners',
                href: '/partners'
              },
              {
                label: 'Press',
                href: '/press'
              },
              {
                label: 'Contact',
                href: '/contact'
              }].
              map((item) =>
              <li key={item.label}>
                  <Link
                  to={item.href}
                  className="text-gray-300 hover:text-white transition-colors"
                  data-testid={`footer-link-company-${item.label.toLowerCase().replace(/ /g, '-')}`}>
                  
                    {item.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-4 text-sm text-gray-300">
            <span>© {new Date().getFullYear()} OpenChambers.org</span>
            <Link
              to="/privacy"
              className="hover:text-white transition-colors"
              data-testid="footer-link-privacy">
              
              Privacy
            </Link>
            <Link
              to="/terms"
              className="hover:text-white transition-colors"
              data-testid="footer-link-terms">
              
              Terms
            </Link>
            <Link
              to="/security"
              className="hover:text-white transition-colors"
              data-testid="footer-link-security">
              
              Security
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="https://github.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="GitHub"
              data-testid="footer-link-github">
              
              <Github className="h-5 w-5" />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="Twitter"
              data-testid="footer-link-twitter">
              
              <Twitter className="h-5 w-5" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="LinkedIn"
              data-testid="footer-link-linkedin">
              
              <Linkedin className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>);

}